/**
 * Firebase -> SQL gecis modu (sirket bazli).
 *
 * "HybridFallback" = mevcut sirket: SQL-once okunur, SQL bos/hatali olursa
 *                    Firebase RTDB okuma-yedegine duser.
 * "SqlOnly"        = yeni sirket / gecis tamamlanmis: Firebase'e HIC bakilmaz.
 *
 * Bu modul, hook disindan (servislerden) de okunabilsin diye modul-seviyesi
 * bir cache tutar. AuthContext login sonrasi `/api/Company`'den okuyup buraya yazar.
 * Varsayilan guvenli taraf: HybridFallback.
 */

export type MigrationMode = 'HybridFallback' | 'SqlOnly';

const DEFAULT_MODE: MigrationMode = 'HybridFallback';

let currentMode: MigrationMode = DEFAULT_MODE;

/** Mevcut gecis modunu dondurur (default: HybridFallback). */
export function getMigrationMode(): MigrationMode {
  return currentMode;
}

/** Gecis modunu set eder. Bilinmeyen/bos deger gelirse guvenli tarafa (HybridFallback) duser. */
export function setMigrationMode(mode: string | null | undefined): void {
  currentMode = mode === 'SqlOnly' ? 'SqlOnly' : DEFAULT_MODE;
}

/** SqlOnly mi? (Firebase'e bakilmamali mi?) */
export function isSqlOnly(): boolean {
  return currentMode === 'SqlOnly';
}
